import React, { useState, useEffect, useRef, useContext } from "react";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

import Card from "../../../../Base/Components/Card/Card";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";

import { getMotoristas } from "../../../../API/Global/Motoristas/MotoristasRequest";
import MotoristasCRUD from "./MotoristasCRUD";

export const MotoristasScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [data, setData] = useState([]);
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(true);

  const getInfo = async () => {
    setLoading(true);
    const dataTempo = await getMotoristas();
    setData(dataTempo);
    setLoading(false);
  };

  const colums = [
    {
      field: "IdMotorista",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      frozen: true,
      headerEn: "Name",
      className: "XXsmall",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Nombre",
      header: "Nombre",
      className: "Xlarge",
      headerEn: "Name",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
      setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Apellido",
      header: "Apellido",
      headerEn: "Last Name",
      className: "Xlarge",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "CodigoPersonal",
      header: "Código",
      className: "Xlarge",
      headerEn: "Code",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Identificacion",
      header: "Identificación",
      className: "Xlarge",
      flex: 1,
      headerEn: "Identification",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      frozen: true,
      className: "small",
      Format: "Estado",
      filter: false,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
    },
    {
      field: "TipoLicencia",
      header: "Licencia",
      className: "Xlarge",
      headerEn: "Licencia",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "IdVehiculo",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          className: "custom-tooltip",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
          tooltipOptions: {
            position: "left",
          },
        },
      ],
    },
  ];

  const table = {
    Columns: colums,
    Data: data,
    loading: loading,
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "motoristas", config.language));
    getInfo();
  }, []);

  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast}></Toast>
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "motoristas", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              severity="success"
              onClick={() => {
                setShowDialog(true);
                setSelected(null);
              }}
            />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />
      {showDialog && <MotoristasCRUD toastRef={toast} showDialog={showDialog} selected={selected} setShowDialog={setShowDialog} getInfo={getInfo} modo={selected ? "Editar" : "Crear"}/>}
    </div>
  );
};

export default MotoristasScreen;
